var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6875 18C1.2375 18 0.84375 17.8312 0.50625 17.4937C0.16875 17.1562 0 16.7625 0 16.3125V12.2906H1.6875V16.3125H16.3125V12.2906H18V16.3125C18 16.7625 17.8312 17.1562 17.4937 17.4937C17.1562 17.8312 16.7625 18 16.3125 18H1.6875ZM9 13.6969L3.57188 8.26875L4.78125 7.05937L8.15625 10.4344V0H9.84375V10.4344L13.2188 7.05937L14.4281 8.26875L9 13.6969Z",
    fill: "#1773BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.3a8849779d6c648ead5027335e241aaa.svg";
export { ForwardRef as ReactComponent };